module.exports = __webpack_public_path__ + "static/how-to-6-0d3a00724d99bb6f2949803285886268.webp";